import axios from "axios";
import { userCredentials } from "DTO/userLoginDto";
import {
  IUser,
  IUsers,
  MapDashboardParams,
  MetricsType,
  userWorkOrderListDto,
  WorkOrderData,
  workOrderInfoResponse,
} from "DTO/userWorkOrderListDto";
import { endPoints } from "./SeriviceEndpoints";
import { AppConfType, ApprovalResponseType } from "types";
import { addHeaders } from "Utils/Utils";

export const userLogin = async (data: userCredentials) => {
  try {
    const user = await axios.post<IUser>(`${endPoints.login}`, data, {
      withCredentials: true,
    });

    if (user.status === 200) {
      return user;
    }
  } catch (err) {
    throw err;
  }
};

export const userSSOLogin = async () => {
  window.location.href = `${process.env.REACT_APP_API_URL}/${endPoints.ssoLogin}?platform=web`;
};
export const token = async () => {
  try {
    const user = await axios.get<IUser>(`${endPoints.currentUser}`, {
      withCredentials: true,
    });
    if (user.status === 200) return user.data;
  } catch (error) {
    return null;
  }
};

export const userLogout = async () => {
  try {
    const res = await axios.post(
      `${endPoints.logout}`,
      {},
      { withCredentials: true }
    );
    if (res.status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const getAppConfig = async () => {
  try {
    const res = await axios.get<AppConfType>(`${endPoints.appconfig}`, {
      withCredentials: true,
    });
    if (res.status === 200) return res.data;
  } catch (error) {
    throw error;
  }
};

export const getWorkOrderList = async () => {
  try {
    const user = await axios.get<[WorkOrderData]>(
      `${endPoints.getWorkOrderList}`,
      { withCredentials: true }
    );

    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkOrderListMap = async (params: MapDashboardParams) => {
  try {
    const user = await axios.get(
      `${endPoints.getWorkOrderListMap}` +
        `?zoom=` +
        params?.zoom +
        `&min_longitude=` +
        params?.min_latitude +
        `&min_latitude=` +
        params?.min_longitude +
        `&max_longitude=` +
        params?.max_latitude +
        `&max_latitude=` +
        params?.max_longitude +
        `&platform=` +
        params?.platform
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getChartData = async (id) => {
  try {
    const user = await axios.get(
      "api/v1/reports/report-stats?platform=web&year=" + id,
      { withCredentials: true }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getActiveWorkOrder = async (type: string) => {
  try {
    const user = await axios.get(
      `/get-active-workorders?casetype=${type}&page_num=1&page_size=10000`,
      { withCredentials: true }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkOrderListbyCaseStatus = async (
  status: String,
  pageSize: number,
  pageNum: number
) => {
  try {
    const user = await axios.get<[userWorkOrderListDto]>(
      `${endPoints.getWorkOrderByCaseStatus}`,
      {
        params: {
          casetype: "cable indication",
          casestatus: status,
          page_size: pageSize,
          page_num: pageNum,
        },
        withCredentials: true,
      }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkOrderListbyCaseType = async (type, pageSize, pageNum) => {
  try {
    const user = await axios.get<[userWorkOrderListDto]>(
      `${endPoints.getWorkOrderByCaseType}`,
      { params: { casetype: type, page_size: pageSize, page_num: pageNum } }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkOrderListPaged = async (pageSize, pageNum) => {
  // console.log("Where is it from?");
  try {
    const user = await axios.get<[userWorkOrderListDto]>(
      `${endPoints.getWorkOrderListPaged}`,
      { params: { page_size: pageSize, page_num: pageNum } }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkerOrderInfo = async (WOid: string, caseId: string) => {
  try {
    const user = await axios.post<workOrderInfoResponse>(
      `${endPoints.getWorkorderInfo}`,
      {
        case_id: caseId,
        workorder_id: WOid,
      },
      addHeaders()
    );

    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkerOrderbyId = async (caseId: string) => {
  try {
    const order = await axios.get<WorkOrderData>(
      `${endPoints.getWorkOrderById}?caseid=${caseId}`,
      addHeaders()
    );
    if (order.status === 200) {
      return order.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getWorkOrderByCaseStatus = async (
  casetype: string,
  casestatus: string
) => {
  try {
    const user = await axios.get(
      `/get-workorder-by-case-status?casetype=${casetype}&casestatus=${casestatus}&page_num=1&page_size=10000`
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getMetrics = async () => {
  try {
    const user = await axios.get<MetricsType>(
      `${endPoints.getDashboardMetrics}`,
      { withCredentials: true }
    );
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

export const getGraphData = async () => {
  try {
    const user = await axios.get(`${endPoints.getGraphData}`);
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};

type epsgFormatType = {
  case_id: string;
  requested_crs: number;
};

export const getNewFileFormat = async (payload: epsgFormatType) => {
  try {
    const res = await axios.post(`${endPoints.epsgFormat}`, payload, {
      responseType: "blob",
      ...addHeaders(),
    });
    if (res.status === 200) {
      const blob = new Blob([res.data], { type: "application/zip" });

      const contentDisposition = res.headers["Content-Disposition"];
      const filenameMatch = contentDisposition?.match(/filename="?(.+)"?/);
      const filename = filenameMatch ? filenameMatch[1] : "downloaded.zip";

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    return false;
  }
};

export const addlog = async (body: { case_id: string; activity: string }) => {
  try {
    const user = await axios.post<{ case_id: string; activity: string }>(
      `${endPoints.addlogs}`,
      JSON.stringify([body]),
      addHeaders({ "Content-Type": "application/json" })
    );
    if (user.status === 200) {
      return true;
    }
  } catch (err) {
    return false;
  }
};

export const updateWorkOrderStatus = async (
  case_id: string,
  status: string,
  comment: string
) => {
  const data = {
    Status: status,
    Comment: comment,
  };

  try {
    const state = JSON.stringify({
      workorder: {
        case_id: case_id,
        workorder_id: case_id,
      },
      data,
    });
    const res = await axios.post(
      `${endPoints.updateStatus}`,
      state,
      addHeaders()
    );
    if (res.status === 200) {
      return true;
    }
  } catch (err) {
    throw err;
  }
};

export const getUsersList = async () => {
  try {
    const user = await axios.get<IUsers>(`${endPoints.getTenantUsersList}`, {
      withCredentials: true,
    });
    if (user.status === 200) {
      return user.data;
    }
  } catch (err) {
    throw err;
  }
};
type assignWorkorderType = {
  case_id: string;
  new_assignee_username: string;
};
export const assignWorkOrder = async (body: assignWorkorderType) => {
  try {
    const res = await axios.post(
      `${endPoints.assignWorkOrder}`,
      body,
      addHeaders()
    );
    if (res.status === 200) return res.data;
  } catch (error) {
    throw error;
  }
};
export const postUser = async (newUser) => {
  try {
    const res = await axios.post(
      `${endPoints.addTenantUser}`,
      newUser,
      addHeaders()
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (err) {
    throw err;
  }
};

export const deleteUser = async (user) => {
  try {
    const res = await axios.post(
      `${endPoints.deleteTenantUser}`,
      user,
      addHeaders()
    );
    if (res.status === 200) {
      return true;
    }
  } catch (err) {
    throw err;
  }
};

export const putUser = async (userData) => {
  try {
    const res = await axios.put(`${endPoints.resetUserPassword}`, userData);
    if (res.status === 200) {
      return true;
    }
  } catch (err) {
    throw err;
  }
};

export const uploadCaseFile = async (WOId, file) => {
  try {
    let formData = new FormData();
    formData.append("case_id", WOId);
    formData.append("file", file);

    const res = await axios.post(
      `${endPoints.uploadProjectCaseFile}`,
      formData,
      addHeaders({ "Content-Type": "multipart/form-data" })
    );
    if (res.status === 200) {
      return true;
    }
  } catch (err) {
    throw err;
  }
};

export const updateApproval = async (
  WOCaseId: string
): Promise<ApprovalResponseType> => {
  try {
    const res = await axios.put(
      `${endPoints.updateApproval}?case_id=${WOCaseId}`,
      {},
      addHeaders()
    );
    if (res.status === 200) return res.data;
  } catch (err: any) {
    return err.message;
  }
};
